module.exports = __webpack_public_path__ + "static/media/rm_06-12.699c75bf.png";